import { useChannelStateContext } from "stream-chat-react";

type ChannelAiStatus = {
  channelId: string;
  isAiEnabled: boolean;
  aiDisabledByName: string | null;
};

export const useChannelAiStatus = (): ChannelAiStatus => {
  const { channel } = useChannelStateContext();
  const channelId = channel.id || "";
  const channelData = channel?.data as
    | {
        channel_ai_enabled?: boolean;
        channel_ai_disabled_by_name?: string | null;
      }
    | undefined;

  const isAiEnabled = channelData?.channel_ai_enabled ?? true;
  const aiDisabledByName = channelData?.channel_ai_disabled_by_name ?? null;

  return { channelId, isAiEnabled, aiDisabledByName };
};
